import { render, staticRenderFns } from "./ProfileVersionHistory.vue?vue&type=template&id=61a7ac15&scoped=true"
import script from "./ProfileVersionHistory.vue?vue&type=script&lang=js"
export * from "./ProfileVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./ProfileVersionHistory.vue?vue&type=style&index=0&id=61a7ac15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7ac15",
  null
  
)

export default component.exports